var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "twitch tv gaming stream gamer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,3H6A1,1,0,0,0,5,4V19a1,1,0,0,0,2,0V5H25V17.59L20.59,22H15a1,1,0,0,0-.71.29l-2.79,2.8V23a1,1,0,0,0-1-1H6a1,1,0,0,0,0,2H9.5v3.5a1,1,0,0,0,.62.92.84.84,0,0,0,.38.08,1,1,0,0,0,.71-.29L15.41,24H21a1,1,0,0,0,.71-.29l5-5A1,1,0,0,0,27,18V4A1,1,0,0,0,26,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16V11a1 1 0 0 0-2 0v5a1 1 0 0 0 2 0zM21 16V11a1 1 0 0 0-2 0v5a1 1 0 0 0 2 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.74b77dd580e65df263eefe6f764e7919.svg";
export { ForwardRef as ReactComponent };